var map = {
	"./de.json": [
		"../locale/res/wordlists/de.json",
		"locale_res_wordlists_de_json"
	],
	"./en.json": [
		"../locale/res/wordlists/en.json",
		"locale_res_wordlists_en_json"
	],
	"./es.json": [
		"../locale/res/wordlists/es.json",
		"locale_res_wordlists_es_json"
	],
	"./fr.json": [
		"../locale/res/wordlists/fr.json",
		"locale_res_wordlists_fr_json"
	],
	"./pt.json": [
		"../locale/res/wordlists/pt.json",
		"locale_res_wordlists_pt_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "../locale/res/wordlists lazy recursive ^\\.\\/.*\\.json$";
module.exports = webpackAsyncContext;